module.exports = "/img/download.0cd78f42.png";